import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminHelpers from "../../../services/admin/admin.service";
// import { IBadgesData } from "../../../models/admin/badges/badges.model";
import { ICourseType } from "../../../models/course.model";

export const UpdateTechnicalityModal: React.FC<any> = ({
  isOpenEdittechnicality,
  onClosed,
  isEdittechnicality = false,
  reload,
  technicality,
}: {
  isEdittechnicality: boolean;
  isOpenEdittechnicality: any;
  onClosed: any;
  reload: any;
  technicality: ICourseType;
}) => {
  const toast = useToast();
  const cancelRef = useRef().current;
  const navigate = useNavigate();

  const [type, setType] = useState(["user", "sponsor", "course", "center"]);

  useEffect(() => {
    if (technicality) {
      formik.setValues({
        name: technicality.name,
        // description: badge.description,
        // badgeType: badge.type,
      });
    }
  }, []);
  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.name) {
        errors.name = "Enter technicality name";
      }
      // if (!values.description) {
      //     errors.description = "enter description";
      // }  if (!values.badgeType) {
      //     errors.badgeType = "select badge type";
      // }
      return errors;
    },
    initialValues: {
      name: "",
      // description: "",
      // badgeType :""
    },
    onSubmit: async (values) => {
      try {
        const new_param: any = {
          name: values.name,
          // description: values.description,
          // type: values.badgeType,
        };
        // const create_param: any = await BadgeService.updateBadge(new_param, badge.uuid)
        const create_param: any = await AdminHelpers.updateCourseTechnicality(
          new_param,
          technicality.uuid
        );

        if (create_param) {
          toast({
            title: "Course Technicality ",
            description: "Course Technicality updated successfully",
            status: "success",
          });
          onClosed(!isEdittechnicality);
          reload();
        } else {
          toast({
            title: "Course Technicality ",
            description: `${create_param.message}`,
            status: "error",
          });
        }
      } catch (error: any) {
        toast({
          title: "Course Technicality ",
          description: `${error}`,
          status: "error",
        });
      }
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpenEdittechnicality && isEdittechnicality}
        onClose={onClosed}
        scrollBehavior="outside"
        closeOnOverlayClick={true}
        size="lg"
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={6}>
          <ModalHeader>
            {
              <Text fontSize={"18px"} pb={3} textTransform="capitalize">
                Edit Technicality
              </Text>
            }
          </ModalHeader>
          <ModalCloseButton size="sm" />
          <ModalBody pb={"30px"}>
            <Box mt={2}>
              <form onSubmit={formik.handleSubmit}>
                <FormControl
                  mb={"20px"}
                  isInvalid={
                    formik.errors.name && formik.touched.name ? true : false
                  }
                >
                  <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                    Name
                  </FormLabel>
                  <Input
                    type="text"
                    id="name"
                    name="name"
                    value={formik.values.name}
                    placeholder="Enter technicality name"
                    onChange={formik.handleChange}
                    fontSize={13}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.name}
                  </FormErrorMessage>
                </FormControl>

                {/* <FormControl
                                    mt={4}
                                    isInvalid={
                                        formik.errors.badgeType && formik.touched.badgeType
                                            ? true
                                            : false
                                    }
                                >
                                    <FormLabel fontWeight="normal" fontSize="13px">
                                        Badge Type
                                    </FormLabel>
                                    <Select
                                        variant="outline"

                                        size="sm"
                                        placeholder="Select type"
                                        value={formik.values.badgeType}
                                        name="badgeType"
                                        onChange={formik.handleChange}
                                        fontSize={12}

                                    >
                                        {type.map((each: string, index: number) => (
                                            <option key={index} value={each}>
                                                {" "}
                                                {each}{" "}
                                            </option>
                                        ))}
                                    </Select>
                                    <FormErrorMessage fontSize={12}>
                                        {formik.errors.badgeType}
                                    </FormErrorMessage>
                                </FormControl> */}
                {/* <FormControl
                                    mt={3}
                                    isInvalid={
                                        formik.errors.description && formik.touched.description ? true : false
                                    }
                                >
                                    <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                                        description
                                    </FormLabel>
                                    <Input
                                        type="text"
                                        id="description"
                                        name="description"
                                        value={formik.values.description}
                                        placeholder="Enter description"
                                        onChange={formik.handleChange}
                                        fontSize={13}
                                    />
                                    <FormErrorMessage fontSize={12}>
                                        {formik.errors.description}
                                    </FormErrorMessage>
                                </FormControl> */}

                <Flex mt={12} justifyContent={"space-between"}>
                  <Button
                    px={6}
                    colorScheme="red"
                    fontSize={"14px"}
                    variant={"outline"}
                    ref={cancelRef}
                    width={"49%"}
                    onClick={() => onClosed()}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    isLoading={formik.isSubmitting}
                    colorScheme="red"
                    width={"49%"}
                    px={6}
                    fontSize={"14px"}
                  >
                    Confirm
                  </Button>
                </Flex>
              </form>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
